<template>
  <div>
    <execute-quiz
      @close="executeQuiz=false; getPending(), getQuestions()"
      v-if="executeQuiz"
      :quizId="selectedQuiz.id"
    />
    <view-quiz
      @close="viewQuizScreen=false; getPending(), getQuestions()"
      v-if="viewQuizScreen"
      :quizId="selectedQuiz.id"
    />

    <section class="lms-container">
      <div class="content">
        <div class="text-center" style="margin-top: 30px;">
          <h4>Atividades Pendentes</h4>
        </div>

        <ul v-if="quizPendingList.length > 0 && countDone != quizPendingList.length" class="exams-list">
          <li v-for="q in quizPendingList" :key="q.id" class="has-answered">
            <div class="exam-info-bar" v-if="!q.quizDone">
              <span class="exam-title">{{q.title}}</span>
              <span class="exam-start">{{q.startDate | formatDate}}</span>
              <span class="exam-end">{{q.endDate | formatDate}}</span>
              <!-- <span class="exam-grade">{{q.moduleName}}</span>
              <span class="exam-grade-number">{{q.grade}}%</span>-->
              <p></p>

              <!-- <quiz-button class="primary" :loading="false" @click="openQuizModal(q)">visualizar</quiz-button> -->
              <quiz-button class="primary" :loading="false" @click="openQuizModal(q)">responder</quiz-button>
            </div>
          </li>
        </ul>

        <div v-else>
          <div class="placeholder-message">
            <h5>Nenhuma avaliação pendente</h5>
          </div>
        </div>
      </div>
    </section>
    <section class="lms-container">
      <div class="content">
        <div class="text-center" style="margin-top: 30px;">
          <h4>Atividades Respondidas</h4>
        </div>

        <ul v-if="quizList.length > 0" class="exams-list">
          <li v-for="q in quizList" :key="q.id" class="has-answered custom-shadow">
            <div class="exam-info-bar">
              <span class="exam-title">{{q.title}}</span>
              <span class="exam-grade">{{q.moduleName}}</span>
              <!-- <span class="exam-grade-number">{{q.grade}}%</span> -->
              <p></p>

              <!-- <quiz-button class="primary" :loading="false" @click="openQuizModal(q)">visualizar</quiz-button> -->
              <quiz-button class="primary" :loading="false" @click="openViewQuiz(q)">visualizar</quiz-button>
            </div>
          </li>
        </ul>

        <div v-else>
          <div class="placeholder-message">
            <h5>Nenhuma avaliação respondida</h5>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import axios from "axios";
import QuizButton from "../../Buttons/QuizButton";
import ViewQuiz from "./ViewQuiz";
import ExecuteQuiz from "../ExecuteQuiz";
import moment from "moment";

export default {
  data() {
    return {
      selectedModuleId: 0,
      executeQuiz: false,
      changedAnswer: 0,
      savingAnswer: 0,
      savingQuestion: false,
      userType: this.$store.getters.user.type,
      quizList: [],
      quizPendingList: [],
      selectedQuiz: {},
      viewQuizScreen: false,
      countDone: 0
    };
  },
  components: {
    QuizButton,
    ViewQuiz,
    ExecuteQuiz
  },
  methods: {
    openQuizModal(quiz) {
      this.selectedQuiz = quiz;
      this.executeQuiz = true;
    },
    openViewQuiz(quiz) {
      this.selectedQuiz = quiz;
      this.viewQuizScreen = true;
    },
    getQuestions() {
      const path = this.$global.endpoint + "/quiz/execution/getall";
      axios
        .post(path, {})
        .then(res => {
          this.quizList = res.data;
          console.log(this.quizList);
          this.checkLists();
        })
        .catch(error => {
          console.error(error);
        });
    },
    getPending() {
      const path = this.$global.endpoint + "/quiz/getpending";
      axios
        .post(path, {})
        .then(res => {
          this.quizPendingList = res.data;
          console.log("lista", this.quizPendingList);
          this.checkLists();
        })
        .catch(error => {
          console.error(error);
        });
    },
    checkLists() {
      for (let i = 0; i < this.quizPendingList.length; i++) {
        let quizPendingItem = this.quizPendingList[i];

        for (let j = 0; j < this.quizList.length; j++) {
          let quizDoneItem = this.quizList[j];

          if (quizPendingItem.id == quizDoneItem.id) {
            this.quizPendingList[i].quizDone = true;
            this.countDone +=1;
          }
        }
      }
    }
  },
  created() {
    this.getQuestions();
    this.getPending();
  }
};
</script>
